import Head from 'next/head';
import React, { Component } from 'react';

const SCRIPT_SRC = 'https://rumcdn.geoedge.be/grumi-ip.js';
const SCRIPT_TIMEOUT = 1500;
let _queue = [];
let _isScriptInHead = false;
let _isReady = false;

class GeoEdge extends Component {
  static onReady(cb) {
    if (_isReady) {
      // Already loaded, call immediately
      cb();
    } else {
      _queue.push(cb);
    }
  }
  static _isReady() {
    if (_isReady) {
      return;
    }
    _isReady = true;
    _queue.forEach(c => c());
    _queue = [];
  }
  componentDidMount() {
    // Only append script once
    if (_isScriptInHead === false) {
      // Note, the script must be appended to the document instead of using
      // <Head> since we need to respond to the load event.
      const script = document.createElement('script');
      script.src = SCRIPT_SRC;
      script.async = true;
      script.onload = GeoEdge._isReady;
      document.head.appendChild(script);
      _isScriptInHead = true;
      // If script does not load before the timeout we should execute all
      // callbacks immediately.
      window.setTimeout(() => {
        if (_isReady === false) {
          GeoEdge._isReady();
        }
      }, SCRIPT_TIMEOUT);
    }
  }
  render() {
    return (
      <Head>
        <script
          key="geoedge-1"
          dangerouslySetInnerHTML={{
            __html: `var WrapperPubKey = '08124b21-e823-442b-b6c5-12c562f86444'; `
          }}
        />
      </Head>
    );
  }
}

export default GeoEdge;
